import React from 'react';

import { useFormikContext } from 'formik';

import LessonGoals from './LessonGoals';

const LessonGoalsContainer = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const handleAddGoalClick = () => {
    setFieldValue('goals', [...values.goals, '']);
  };

  const handleRemoveGoalClick = (goalIndex: any) => {
    setFieldValue(
      'goals',
      values.goals.filter((_: any, index: any) => goalIndex !== index),
    );
  };

  return (
    <LessonGoals
      goals={values.goals}
      onAddGoalClick={handleAddGoalClick}
      onRemoveGoalClick={handleRemoveGoalClick}
    />
  );
};

export default React.memo(LessonGoalsContainer) as any;
